// extracted by mini-css-extract-plugin
module.exports = {"password_successfully":"SetPasswordSuccess_password_successfully__3Caxm","button_successfully":"SetPasswordSuccess_button_successfully__2Rvav"};